import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import Tooltip from '@mui/material/Tooltip';
import packageJson from '../../../package.json';
import './NavFooter.css';

const SITE_URL = 'https://ilocalbox.com/';

function NavFooter({ t, drawerOpen }) {
  const year = new Date().getFullYear();
  const copyright = `${t('Home.Footer.Copyright', {
    defaultValue: 'Copyright',
  })} © 2018 - ${year}`;
  const reserved = t('Home.Footer.AllRightReserved', {
    defaultValue: 'All rights reserved.',
  });
  const brand = t('Home.Footer.iLocalBox', {
    defaultValue: 'iLocalbox.com',
  });
  const versionWord = t('Home.Footer.Version', { defaultValue: 'Version' });

  const body = (
    <div
      className={'nav-footer' + (drawerOpen ? '' : ' is-collapsed')}
      id="react-no-print"
    >
      <p className="nav-footer-copy">
        {drawerOpen ? copyright : `© ${year}`}
      </p>
      <a
        className="nav-footer-link"
        href={SITE_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        {drawerOpen ? brand : 'iLocalBox'}
      </a>
      <div
        className="nav-footer-version"
        title={`${versionWord} ${packageJson.version}`}
      >
        <span className="nav-footer-version-label">{versionWord}</span>
        <span className="nav-footer-version-num">{packageJson.version}</span>
      </div>
    </div>
  );

  if (drawerOpen) {
    return body;
  }

  return (
    <Tooltip
      title={`${copyright}. ${reserved}`}
      placement="right"
      arrow
    >
      {body}
    </Tooltip>
  );
}

NavFooter.propTypes = {
  t: PropTypes.func.isRequired,
  drawerOpen: PropTypes.bool,
};

NavFooter.defaultProps = {
  drawerOpen: true,
};

export default withTranslation()(NavFooter);



// WEBPACK FOOTER //
// ./src/components/leftnav/NavFooter.js